import {
  BatchStatisticsReserveConditionListItem,
  BatchStatisticsReserveConditionListItemFromJSON
} from '@/api/models/batch/BatchStatisticsReserveConditionListItem'

export interface BatchStatisticsReserveSelectItemResult {
  items: BatchStatisticsReserveConditionListItem
}

export function BatchStatisticsReserveSelectItemResultFromJSON(
  json: any
): BatchStatisticsReserveSelectItemResult {
  return {
    items: BatchStatisticsReserveConditionListItemFromJSON(json)
  }
}
